import {
  Button as AntButton,
  ButtonProps as AntButtonProps,
  ConfigProvider,
} from "antd";
import { theme } from "antd";
import { usePalette } from "@/shared/theme";
import { useIsMobile } from "@/shared/adaptive/use-is-mobile";

const { useToken } = theme;

export type ButtonProps = AntButtonProps & {
  success?: boolean;
  accent?: boolean;
  neutral?: boolean;
  mobileText?: string | null;
};

export default function Button({
  success,
  accent,
  neutral,
  mobileText,
  children,
  ...rest
}: ButtonProps) {
  const palette = usePalette();
  const { token } = useToken();
  const isMobile = useIsMobile();

  const btn = (
    // Служебный атрибут идёт первым: значение, которое передал потребитель
    // (data-test / data-testid), не должно перетираться общим компонентом.
    <AntButton data-test="button" {...rest}>
      {isMobile && mobileText !== undefined ? mobileText : children}
    </AntButton>
  );

  if (success) {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: token.colorSuccess,
          },
          components: {
            Button: {
              defaultBorderColor: token.colorSuccess,
              defaultColor: token.colorSuccess,
              textTextColor: token.colorSuccess,
              textTextHoverColor: token.colorSuccess,
              textHoverBg: palette.success[0],
            },
          },
        }}
      >
        {btn}
      </ConfigProvider>
    );
  }

  if (accent) {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: palette.accent[5],
          },
          components: {
            Button: {
              defaultBorderColor: palette.accent[5],
              defaultColor: palette.accent[5],
            },
          },
        }}
      >
        {btn}
      </ConfigProvider>
    );
  }

  if (neutral) {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: palette.neutral[5],
          },
          components: {
            Button: { defaultBg: palette.neutral[5], colorText: "white" },
          },
        }}
      >
        {btn}
      </ConfigProvider>
    );
  }

  return btn;
}
